module.exports = __webpack_public_path__ + "static/img/active@2x.b9ad0693.png";